
namespace Matrix.Exceptions {

    @Serenity.Decorators.registerClass()
    export class ExceptionReviewGrid extends Serenity.EntityGrid<ExceptionReviewRow, any> {
        protected getColumnsKey() { return 'Exceptions.ExceptionReview'; }
        protected getDialogType() { return ExceptionReviewDialog; }
        protected getIdProperty() { return ExceptionReviewRow.idProperty; }
        protected getInsertPermission() { return ExceptionReviewRow.insertPermission; }
        protected getLocalTextPrefix() { return ExceptionReviewRow.localTextPrefix; }
        protected getService() { return ExceptionReviewService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}